














































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
import GlobalMixins from "../../../global.mixin";
import {importExportApi} from "../../../services/api/importexport.api";
import { sitesApi } from "../../../services/api/sites.api";
import LoadingPopup from "../../../components/LoadingPopup.vue";

@Component({
  mixins: [GlobalMixins],
  components: { LoadingPopup }
})
export default class Sites extends Vue {
  @State("sites") sitesState: any;
  @State("costCenters") costCentersState: any;

  @Action("getSites") getSites: any;
  @Action("saveSite") saveSite: any;
  @Action("deleteSite") deleteSite: any;
  @Action("getCostCenters") getCostCenters: any;

  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";
  formValid = false;

  costCentersSearchTerm = "";
  costCentersSearched: string[] = [];

  editingDialog = false;
  isNewSite = false;
  defaultItem = {
    siteId: 0,
    code: "",
    description: "",
    costCenterId: -1,
  };
  editedItem = Object.assign({}, this.defaultItem);
  editedIndex = -1;

  // Upload related properties
  uploadDialog = false;
  uploadDialogTitle = "";
  uploadDialogText = "";
  loading = false;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "code",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("sites-rowsPerPage") ?
                        parseInt(this.$cookies.get("sites-rowsPerPage"), 10) : 25
  };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  getHeaders() { return [
    { text: "#", value: "siteId", width: "1%", align: "left", sortable: true},
    { text: (this as any).$t("SITES_TABLE_HEADER_CODE"), value: "code", width: "1%", align: "left", sortable: true },
    { text: (this as any).$t("SITES_TABLE_HEADER_DESCRIPTION"), value: "description", width: "1%", align: "left", sortable: true },
    { text: (this as any).$t("TABLE_ACTIONS"), value: "", sortable: false,  width: "1%" },
    // { text: "Lokációk", value: "", sortable: false, width: "1%" },
    { text: "", value: "", sortable: false  },
  ];
  }
  async created() {
    await this.getCostCenters();
    this.searchCostCenters(null);
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column, sortable) {
    if (!sortable) {
      return;
    }

    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  updatePagination(pagination) {
    this.$cookies.set("sites-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getSites(page);
  }

  save() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {

        this.saveSite({
          data: JSON.stringify(this.editedItem),
          index: this.editedIndex
        })
        .then(res => {
          this.close();
        })
        .catch(res => {
          // handle....
          // this.close();
        });
      }
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    if (this.$refs.form) {
      // this.$refs.form.resetValidation();
      (this.$refs.form as Vue & { resetValidation: () => void }).resetValidation();
    }
  }

  editItem(item) {
    this.isNewSite = false;
    this.editedIndex = this.sitesState.sites.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.editingDialog = true;
  }

  deleteItem(item) {
    const index = this.sitesState.sites.indexOf(item);

    if (confirm((this as any).$t("SITE_DELETE_CONFIRM") as string)) {
      this.deleteSite({ id: item.siteId, index });
    }
  }

  siteLocations(item) {
    // console.log("inventoryDetails: ", item);

    this.$router.push({
      name: "sites-location",
      params: { siteId: item.siteId, code: item.code, description: item.description, extra: "\" " + item.code + ", " + item.description + "\"" },
    });
  }

  searchCostCenters(e) {
    if (!this.costCentersSearchTerm) {
      this.costCentersSearched = this.costCentersState.costCenters;
      return;
    }

    this.costCentersSearched = this.costCentersState.costCenters.filter((item) => {
      return item.name.indexOf(this.costCentersSearchTerm.toUpperCase()) > -1 ||
             item.description.indexOf(this.costCentersSearchTerm.toUpperCase()) > -1;
    });
  }

  // Download methods
  downloadSitesData() {
    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: this.pagination.sortBy,
      descending: this.pagination.descending,
      page: this.pagination.page,
      rowsPerPage: this.pagination.rowsPerPage,
      searchString: x,
    };
    importExportApi.downloadSiteExport(page, "telephely-export.xlsx");
  }

  // Upload methods
  onPickFile() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  selectFile(event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    this.loading = true;

    sitesApi.upload(file)
      .then(res => {
        if (res.data.status === 1) {
          // success
          this.uploadDialogTitle = "Sikeres betöltés!";
          this.uploadDialogText = res.data.msg;
        } else if (res.data.status === 3) {
          // validation errors
          this.uploadDialogTitle = "Hiba van az adatokban!";
          this.uploadDialogText = res.data.errors.join("<br>");
        } else {
          this.uploadDialogTitle = "Error";
          this.uploadDialogText = res.data.msg || "Unknown error occurred";
        }
        this.loading = false;
        this.uploadDialog = true;
        // Refresh the data after successful upload
        if (res.data.status === 1) {
          this.updatePagination(this.pagination);
        }
      })
      .catch(error => {
        this.loading = false;
        this.uploadDialogTitle = "Unexpected Response!";
        this.uploadDialogText = JSON.stringify(error);
        this.uploadDialog = true;
        console.error("Upload failed:", error);
      });

    // Clear the file input so the same file can be selected again
    event.target.value = "";
  }
}
